module.exports = __webpack_public_path__ + "static/media/heart1.be3b42be.png";